export default __webpack_public_path__ + "static/media/bdt1.07e9c115.svg";